__turbopack_context__.v({
  "checkbox": "checkboxFilter-module-scss-module__oJNMNG__checkbox",
  "columns2": "checkboxFilter-module-scss-module__oJNMNG__columns2",
  "columns3": "checkboxFilter-module-scss-module__oJNMNG__columns3",
  "columns4": "checkboxFilter-module-scss-module__oJNMNG__columns4",
});
